import template from './template.html'
import controller from './canonicalUrl.controller'

export default {
  restrict: 'E',
  template,
  bindings: { storyObj: '<' },
  controller,
  controllerAs: 'vm',
}
